/* eslint-disable */
import * as R from 'ramda';

export default function DocumentAssociationDialogController(
  ssDialogService,
  loaderService,
  alerts,
  docDataService
) {
  const vm = this;

  vm.handleAcceptDialogClick = _handleAcceptDialogClick;
  vm.handleCloseDialogClick = _handleCloseDialogClick;

  vm.documentId = vm.documentId || null;
  vm.folderId = vm.folderId || -1;
  vm.serviceId = vm.serviceId || null;
  vm.service = vm.service || null;
  vm.associations = vm.associations || null;
  vm.document = vm.document || null;
  vm.parentFolder = vm.parentFolder || null;

  _activate();

  function _activate() {
    vm.associations = R.groupWith((a, b) => a.serviceId + a.table === b.serviceId + b.table)(vm.associations);
    // vm.associations = R.sortBy(R.prop("documentId"), vm.associations);
  }

  function _handleAcceptDialogClick() {
    if (vm.acceptCallback) {
      vm.acceptCallback(vm.$event, vm.parentFolder, vm.document, vm.serviceId);
    }

    ssDialogService.hide(ssDialogService.dialogs.global.documentAssociationDialog);
  }

  function _handleCloseDialogClick() {
    if (vm.declineCallback) {
      vm.declineCallback(vm.$event, vm.service);
    }

    ssDialogService.hide(ssDialogService.dialogs.global.documentAssociationDialog);
  }
}

DocumentAssociationDialogController.$inject = [
  'ssDialogService',
  'loaderService',
  'alerts',
  'docDataService'
];
